module.exports = __webpack_public_path__ + "static/media/handbag1.4b8140f4.jpg";